module.exports = __webpack_public_path__ + "img/cropped-owl@4x-270x270.cb1d41ea.png";